// region Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { getXsrfToken } from "../../Store/Security/Actions";
import Modal from "react-modal";
import styled from "styled-components";
import { Translate, I18n } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import { updateLeaseModalState } from "../../Store/Modals/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { submitApprovalCode, approvalCodeFailed } from "../../Store/Checkout/Actions";
Modal.setAppElement("#react-app");
// endregion

// region Style
const ModalBody = styled.div`
    padding: 40px 80px;
    
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
       padding: 40px 15px; 
    }
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        padding: 40px 20px;
    }
`;

const CloseButton = styled.div`
    display: none;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        display: block;
    }
`;

const Logo = styled.img`  
    width: 100px;
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        width: 80px;
    }
`;

const Box = styled.div`
    .col-lg-6:last-of-type & {
        margin-bottom: 0;
    }
  
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        margin-bottom: 0;
        height: 100%;
    }
`;

const FlexRow = styled.div`
    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 992px) {
        display: flex;
    }
`;

const LeaseRow = styled.div`
    margin-bottom: 10px;
`;

const FlexColumn = styled.div`
    ${FlexRow} & {
        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 992px) {
            flex: 1;
        }
    }
`;

const CustomRow = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const HeaderGroup = styled.hgroup`
    margin-bottom: 1.04em;
`;

const H3 = styled.h3`
    ${HeaderGroup} & {
        margin-bottom: 0.5em;
    }
`;

const Button = styled.button`
    width: 130px;
`;

const CustomP = styled.p`
    line-height: 1.5em;
    font-size: 8pt;
    
    ${LeaseRow} & {
        font-size: 10pt;
    }
`;

const StepTitle = styled(CustomP)`
    color: #38a7c6;
    font-weight: bold;
    margin-bottom: 0;
`;

const StepDescription = styled(CustomP)`
    font-weight: bold;
`;
// endregion

class LeaseModal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
    }

    componentWillUnmount() {
        const { reset, approvalCodeFailed } = this.props;

        reset();
        approvalCodeFailed({});
    }

    closeModal() {
        const { updateLeaseModalState, reset, approvalCodeFailed } = this.props;

        updateLeaseModalState(false);
        reset();
        approvalCodeFailed({});
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                {/* <label>{field.label}</label>*/}
                <input type={field.type} placeholder={field.placeholder} {...field.input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    onSubmit(values) {
        const { getXsrfToken, updateLeaseModalState, toggleBlockingStatus, submitApprovalCode, history } = this.props;
        const obj = {
            ApprovalCode: values.ApprovedCode,
            __RequestVerificationToken: values.__RequestVerificationToken
        };

        toggleBlockingStatus(true);

        getXsrfToken(({ token }) => {
            obj.__RequestVerificationToken = token;

            submitApprovalCode(obj, data => {
                history.push(Constants.ENDPOINTS.LEASE_CHECKOUT);

                toggleBlockingStatus(false);
                updateLeaseModalState(false);
            });
        });
    }

    renderErrors() {
        if (this.props.approvalCodeStatus.response) {
            const { response: { data } } = this.props.approvalCodeStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return (
                    <div className="row justify-content-center" style={{ marginBottom: 20 }}>
                        <div className="col-md-12">
                            <div className="alert bg--error" style={{ marginBottom: 0 }}>
                                <div className="alert__body">
                                    <span>{data}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    render() {
        const { leaseModalOpen, handleSubmit, pristine, submitting } = this.props;

        return (
            <Modal
                isOpen={leaseModalOpen}
                onRequestClose={this.closeModal}
                contentLabel="lease alert"
                className="modal-content"
                overlayClassName="modal-container lease-modal modal-active"
                // shouldCloseOnOverlayClick={false}
            >
                <ModalBody className="modal-body">
                    <div className="row justify-content-center" style={{ marginBottom: 20 }}>
                        <div className="col-6">
                            <div className="bar__module text-center">
                                <Link to="#" style={{ cursor: "auto" }}>
                                    <Logo className="logo logo-light logo-desktop" alt="logo" src={require("../../../Assets/Images/logo-velocitor.png")}/>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <FlexRow className="row justify-content-center">
                        <FlexColumn className="col-lg-6">
                            <Box className="boxed boxed--border">
                                <form id="approval-code-form" style={{ marginTop: 0 }} onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <HeaderGroup>
                                        <H3 className="text-center"><strong><Translate value="modals.lease.approvalCode.title1" /></strong></H3>
                                        <h5 className="text-center"><strong><Translate value="modals.lease.approvalCode.title2" /></strong></h5>
                                    </HeaderGroup>

                                    <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
                                        <Field
                                            name="ApprovedCode"
                                            type="text"
                                            label={I18n.t("modals.lease.approvalCode.approvalCode")}
                                            placeholder={I18n.t("modals.lease.approvalCode.approvalCode")}
                                            size="12"
                                            component={this.renderTextField}
                                        />
                                    </div>
                                    {this.renderErrors()}

                                    <div className="row justify-content-center">
                                        <div className="col-md-5">
                                            <Button type="submit" className="btn btn--primary type--uppercase" disabled={pristine || submitting}><Translate value="modals.lease.approvalCode.btn" /></Button>
                                        </div>
                                    </div>
                                </form>

                                <CustomRow className="row justify-content-center" style={{ marginTop: 40 }}>
                                    <div className="col-md-12">
                                        <CustomP>
                                            <strong>
                                                <Translate value="modals.lease.approvalCode.desc1" />
                                            </strong>
                                        </CustomP>

                                        <CustomP>
                                            <strong>
                                                <Translate value="modals.lease.approvalCode.desc2" />
                                            </strong>
                                        </CustomP>
                                    </div>
                                </CustomRow>
                            </Box>
                        </FlexColumn>

                        <FlexColumn className="col-lg-6">
                            <Box className="boxed boxed--border">
                                <h3 className="text-center"><strong><Translate value="modals.lease.leaseApplication.title" /></strong></h3>

                                <LeaseRow className="row justify-content-center">
                                    <div className="col-md-8 text-center">
                                        <StepTitle>
                                            <Translate value="modals.lease.leaseApplication.step" number={1} />
                                        </StepTitle>
                                        <StepDescription>
                                            <Translate value="modals.lease.leaseApplication.steps.one.description" />
                                        </StepDescription>
                                    </div>
                                </LeaseRow>
                                <LeaseRow className="row justify-content-center">
                                    <div className="col-md-8 text-center">
                                        <StepTitle>
                                            <Translate value="modals.lease.leaseApplication.step" number={2} />
                                        </StepTitle>
                                        <StepDescription>
                                            <Translate value="modals.lease.leaseApplication.steps.two.description" />
                                        </StepDescription>
                                    </div>
                                </LeaseRow>

                                <div className="row justify-content-center" style={{ marginTop: 20 }}>
                                    <div className="col-md-5 text-center">
                                        <Link to={Constants.ENDPOINTS.LEASE_APPLICATION} onClick={this.closeModal}>
                                            <Button type="button" className="btn btn--primary type--uppercase"><Translate value="modals.lease.leaseApplication.btn" /></Button>
                                        </Link>
                                    </div>
                                </div>
                            </Box>
                        </FlexColumn>
                    </FlexRow>
                </ModalBody>
                <CloseButton className="modal-close modal-close-cross" onClick={this.closeModal}/>
            </Modal>
        );
    }
}

LeaseModal.propTypes = {
    getXsrfToken: PropTypes.func,
    updateLeaseModalState: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    submitApprovalCode: PropTypes.func,
    approvalCodeFailed: PropTypes.func,
    i18n: PropTypes.object,
    leaseModalOpen: PropTypes.bool,
    approvalCodeStatus: PropTypes.object,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        leaseModalOpen: state.leaseModalOpen,
        approvalCodeStatus: state.approvalCodeStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        updateLeaseModalState: updateLeaseModalState,
        toggleBlockingStatus: toggleBlockingStatus,
        submitApprovalCode: submitApprovalCode,
        approvalCodeFailed: approvalCodeFailed
    }, dispatch);
}

export default reduxForm({
    // validate,
    form: "LeaseApprovedCode"
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(LeaseModal))
);